module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAAHUlEQVQImWM81Jr5nwEKGF9dWYXgSIioQjgMDAwAvmoHai5R7rMAAAAASUVORK5CYII="